import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, StatCard } from "../components/common/PageParts";

export default function Performance() {
  const [perf, setPerf] = useState(null);
  useEffect(() => { api.getPerformance().then(setPerf).catch(() => {}); const t = setInterval(() => api.getPerformance().then(setPerf).catch(() => {}), 10000); return () => clearInterval(t); }, []);

  const curve = perf?.equityCurve || [{ i: 0, equity: 10000 }];
  const min = Math.min(...curve.map((c) => c.equity));
  const max = Math.max(...curve.map((c) => c.equity));
  const range = max - min || 1;
  const W = 800, H = 240;
  const pts = curve.map((c, i) => `${(i / Math.max(curve.length - 1, 1)) * W},${H - ((c.equity - min) / range) * (H - 20) - 10}`);

  return (
    <div className="ym-fade">
      <PageHeader title="Performa" subtitle={perf?.dataQuality === "INSUFFICIENT_DATA" ? `Paper-trading results — DATA BELUM CUKUP: ${perf?.note}` : "Paper-trading results & equity curve"} />

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-4">
        <StatCard label="Total Trades" value={perf?.trades ?? 0} />
        <StatCard label="Win Rate" value={perf?.winRate == null ? "N/A" : `${perf.winRate}%`} color="var(--green)" />
        <StatCard label="Wins" value={perf?.wins ?? 0} color="var(--green)" />
        <StatCard label="Losses" value={perf?.losses ?? 0} color="var(--red)" />
        <StatCard label="Total PnL" value={perf?.dataQuality === "INSUFFICIENT_DATA" ? "—" : `$${perf?.totalPnl ?? 0}`} color={(perf?.totalPnl ?? 0) >= 0 ? "var(--green)" : "var(--red)"} />
      </div>

      <div className="ym-panel p-4">
        <h3 className="text-[13px] font-bold mb-3">Equity Curve <span className="text-[11px]" style={{ color: "var(--text-dim)" }}>(start $10,000)</span></h3>
        <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{ height: 240 }}>
          <defs>
            <linearGradient id="eq" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#8b5cf6" stopOpacity="0.35" />
              <stop offset="100%" stopColor="#8b5cf6" stopOpacity="0" />
            </linearGradient>
          </defs>
          <polyline points={`0,${H} ${pts.join(" ")} ${W},${H}`} fill="url(#eq)" stroke="none" />
          <polyline points={pts.join(" ")} fill="none" stroke="#a78bfa" strokeWidth="2" />
        </svg>
        {(!perf || perf.trades === 0) && <p className="text-center text-[12px] mt-2" style={{ color: "var(--text-dim)" }}>Close some paper trades to build your equity curve.</p>}
      </div>
    </div>
  );
}
